import {
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    TabsProps,
    Grid,
} from '@cxc/react-fpds-components';
import TabSectionProps from '../../types/props/TabSectionProps';
import styles from './TabSection.module.scss';
import { useState } from 'react';
import { TabTitles } from '../../constants/DetailsPageConstants';
import ChangeLogPanel from './ChangeLog/ChangeLogPanel';
import { OverviewPanel } from './Overview/OverviewPanel';
import { EligibilityPanel } from './Eligibility/EligibilityPanel';
import { FundingPanel } from './Funding/FundingPanel';

const TabSection = ({ incentive }: TabSectionProps) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleSetActiveTab = (tabNum: number) => {
        setActiveTab(tabNum);
    };

    const tabProps: TabsProps = {
        size: 'medium',
        activeTab: activeTab,
        setActiveTab: handleSetActiveTab,
        isBottomBorderFullWidth: true,
        borderBottom: true,
        children: undefined,
    };

    return (
        <Grid className={styles.gridStyle}>
            <Tabs {...tabProps}>
                <TabList>
                    <Tab>{TabTitles.OVERVIEW}</Tab>
                    <Tab>{TabTitles.ELIGIBILITY}</Tab>
                    <Tab>{TabTitles.FUNDING}</Tab>
                    <Tab>{TabTitles.CHANGELOG}</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel className={styles.contentStyle}>
                        <OverviewPanel incentive={incentive} />
                    </TabPanel>
                    <TabPanel className={styles.contentStyle}>
                        <EligibilityPanel incentive={incentive} />
                    </TabPanel>
                    <TabPanel className={styles.contentStyle}>
                        <FundingPanel incentive={incentive} />
                    </TabPanel>
                    <TabPanel className={styles.contentStyle}>
                        <ChangeLogPanel incentive={incentive} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Grid>
    );
};

export default TabSection;
